class VariantPopup extends HTMLElement {
  constructor() {
    super();
    this.formId = this.getAttribute("popup-form-id");
    this.name = this.getAttribute("name");
    this.variantId = this.getAttribute("data-variant-id");
    this.currentVariant = this.getAttribute("data-current-variant");
    this.specificColors =
      this.getAttribute("data-specific-color")
        ?.split(",")
        .map((color) => color.trim()) || [];
  }

  async connectedCallback() {
    this.template = this.querySelector("template");

    await this.loadContent();
    await this.setupForm();
    console.log("connectedCallback", this.form);
    this.initializeVariants();
    await this.bindEvents();
  }

  initializeVariants() {
    console.log("initializeVariants");
    if (!this.form) return;

    // 设置默认变体ID
    if (this.variantId) {
      const hiddenInput = this.form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = this.variantId;
      }
    }

    // 处理颜色选项
    const colorOptions = this.form.querySelectorAll(
      ".variant-picker__new_Color [data-option-selector] [data-option-value]"
    );
    const colorOptionInputs = this.form.querySelectorAll(".variant-picker__new_Color [data-option-selector] input");
    colorOptionInputs.forEach((option, index) => {
      const value = option.getAttribute("value");
      console.log(value, "colorOptionInputs");
      // 如果有指定颜色，隐藏不在列表中的选项
      if (this.specificColors.length > 0) {
        if (!this.specificColors.includes(value)) {
          colorOptions[index].style.display = "none";
          option.style.display = "none";
        }
      }
      if (this.currentVariant.includes(value)) {
        colorOptions[index].click();
      }
    });
  }

  loadContent() {
    if (this.template) {
      const content = this.template.content.cloneNode(true);
      // 移除多余的空白文本节点
      Array.from(content.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === "") {
          content.removeChild(node);
        }
      });
      this.appendChild(content);
      this.template.remove();
    }
  }

  setupForm() {
    this.form = this.querySelector(`#${this.formId}`);
    console.log(this.form, "setupForm");
    this.confirmButton = this.querySelector('[data-action="confirm"]');
  }

  disconnectedCallback() {
    this.confirmButton?.removeEventListener("click", this.handleConfirm);
  }

  bindEvents() {
    if (this.confirmButton) {
      this.confirmButton.addEventListener("click", this.handleConfirm.bind(this));
    }
  }

  async handleConfirm() {
    const variantId = this.form.querySelector('[name="id"]').value;
    const event = new CustomEvent("variantSelected", {
      detail: {
        variantId: variantId,
        formId: this.form.id,
        productId: this.getAttribute("product-id"),
      },
    });
    document.dispatchEvent(event);

    // 更新 combo-item
    await this.updateComboItem(variantId);

    const dialog = this.closest("dialog");
    if (dialog) {
      dialog.close();
    }
  }

  async updateComboItem(variantId) {
    const comboItem = this.closest("." + this.name);
    console.log("updateComboItem", comboItem);
    if (!comboItem) return;

    try {
      // 获取新的变体数据
      const response = await fetch(`${window.Shopify.routes.root}variants/${variantId}.js`);
      const variantData = await response.json();

      // 更新复选框的值和数据属性
      const checkbox = comboItem.querySelector("[data-variant-checkbox]");
      if (checkbox) {
        checkbox.value = variantId;
        checkbox.dataset.price = variantData.price;
        checkbox.dataset.sku = variantData.sku;
      }

      // 更新图片
      const image = comboItem.querySelector("." + this.name + "__image");
      if (image && variantData.featured_image) {
        image.src = variantData.featured_image.src;
        image.srcset = "";
      }

      // 更新变体标题
      const variantTitle = comboItem.querySelector("." + this.name + "__variant span");
      console.log("variantTitle", variantTitle);
      if (variantTitle) {
        variantTitle.textContent = variantData.title;
      }

      // 更新价格
      const price = comboItem.querySelector(".price");
      if (price) {
        price.textContent = '$'+ Number(variantData.price / 100).toFixed(2);
      }
      this.confirmButton.removeAttribute("disabled");
      this.confirmButton.removeAttribute("aria-busy");
      // 触发价格重新计算事件
      document.dispatchEvent(new CustomEvent("variant:changed"));
    } catch (error) {
      this.confirmButton.removeAttribute("disabled");
      this.confirmButton.removeAttribute("aria-busy");
      console.error("更新变体失败:", error);
    }
  }

}

if (!customElements.get("variant-popup")) {
  customElements.define("variant-popup", VariantPopup);
}
